import { render, staticRenderFns } from "./MdChip.vue?vue&type=template&id=408e2f87"
import script from "./MdChip.vue?vue&type=script&lang=js"
export * from "./MdChip.vue?vue&type=script&lang=js"
import style0 from "./MdChip.vue?vue&type=style&index=0&id=408e2f87&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports